export default __webpack_public_path__ + "static/media/AachalShrestha.5f5ba0c1.webp";